import { Button } from "@/components/ui/baseUi/button"
import { cn } from "@/modules/lib/utils"
import { ChevronIcon } from "@images/svgIcons/chevronIcon"
import { word } from "@modules/core/utils/i18n"
import { PublicProfileDetails } from "@modules/profile/publicProfile/components/publicProfileDetails"
import { useUserProfile } from "@modules/profile/publicProfile/hooks/useUserProfile"
import { HuAvatarCardSidebar } from "@modules/ui/components/huAvatarCardSidebar"
import { LoadingSpinner } from "@modules/ui/components/loading"
import { useState } from "react"

type PublicProfileInfoResumeProps = {
  userId: string
  className?: string
} & React.ComponentProps<"div">

export function PublicProfileInfoResume({ userId, className, ...props }: PublicProfileInfoResumeProps) {
  const [isBioCollapsed, setIsBioCollapsed] = useState<boolean>(true)
  const { data: viewedUser, isLoading } = useUserProfile(userId)

  const toggleBio = () => setIsBioCollapsed((value) => !value)

  if (isLoading || !viewedUser) {
    return <LoadingSpinner />
  }

  return (
    <div className={cn("flex w-full flex-col", className)} {...props}>
      <HuAvatarCardSidebar
        id={viewedUser.userId}
        avatar={viewedUser.avatar ?? undefined}
        firstname={viewedUser.firstname ?? undefined}
        lastname={viewedUser.lastname ?? undefined}
        username={viewedUser.username ?? undefined}
        prefixUsername={viewedUser.username ? "@" : undefined}
        nationality={viewedUser.nationality ?? undefined}
        bottomButton={
          <Button data-testid="see-profile-details" variant="underline" onClick={toggleBio}>
            {isBioCollapsed ? word("publicProfile.openProfile") : word("publicProfile.closeProfile")}
            <ChevronIcon
              color="currentColor"
              width={10}
              height={10}
              className="text-textDefault-body"
              transform={isBioCollapsed ? "rotate(0)" : "rotate(180)"}
            />
          </Button>
        }
      />
      <PublicProfileDetails publicProfile={viewedUser} isBioCollapsed={isBioCollapsed} isBioCollapsible={true} />
    </div>
  )
}
